import { Field, FieldProps } from 'formik'
import { useState } from 'react'

import { AssignUserControl, AssignUserControlProps } from '.'
import { UserId } from '@cibo/core'

interface AssignUserFieldProps extends Omit<AssignUserControlProps, 'setFullText' | 'setUserId'> {
  name?: string
}

export const AssignUserField = ({ name = 'user', ...props }: AssignUserFieldProps) => {
  const [fullText, setFullText] = useState<string>()

  return (
    <Field name={name}>
      {({ form: { values, setFieldValue }, meta: { error, touched } }: FieldProps) => (
        <AssignUserControl
          fullText={fullText}
          setFullText={setFullText}
          setUserId={(value?: UserId) => setFieldValue(name, value)}
          userId={values[name]}
          textFieldProps={{ error: !!error, helperText: error }}
          {...props}
        />
      )}
    </Field>
  )
}
